var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.33341V6.60008C16.5 5.57332 16.5 5.05993 16.3002 4.66777C16.1244 4.3228 15.8439 4.04233 15.499 3.86657C15.1069 3.66675 14.5934 3.66675 13.5667 3.66675H5.68333C4.65657 3.66675 4.14319 3.66675 3.75102 3.86657C3.40605 4.04233 3.12559 4.3228 2.94982 4.66777C2.75 5.05993 2.75 5.57332 2.75 6.60008V7.33341M2.75 7.33341V15.4001C2.75 16.4268 2.75 16.9403 2.94982 17.3324C3.12559 17.6774 3.40605 17.9579 3.75102 18.1336C4.14319 18.3334 4.65657 18.3334 5.68333 18.3334H16.3167C17.3434 18.3334 17.8569 18.3334 18.249 18.1336C18.5939 17.9579 18.8744 17.6774 19.0502 17.3324C19.25 16.9403 19.25 16.4268 19.25 15.4001V10.2667C19.25 9.23999 19.25 8.7266 19.0502 8.33443C18.8744 7.98946 18.5939 7.709 18.249 7.53324C17.8569 7.33341 17.3434 7.33341 16.3167 7.33341H2.75ZM19.25 11.0001H17.4167C16.4041 11.0001 15.5833 11.8209 15.5833 12.8334C15.5833 13.846 16.4041 14.6667 17.4167 14.6667H19.25",
    stroke: "#4A4A53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.2c135829fd50e07767eb46546dbdfbfb.svg";
export { ForwardRef as ReactComponent };